import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
	meta: {
		title: "MVM Logstics - Home",
	}
  },
  {
    path: '/contact',
    name: 'Contact Us',
    component: () => import('../views/Contact.vue'),
	meta: {
		title: "MVM Logstics - Contact",
	}
  },
  {
    path: '/terms',
    name: 'T&Cs',
    component: () => import('../views/T&Cs.vue'),
	meta: {
		title: "MVM Logstics - T&C's",
	}
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue'),
	meta: {
		title: "MVM Logstics - Services",
	}
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('../views/404.vue'),
	meta: {
		title: "MVM Logstics - 404",
	}
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

const DEFAULT_TITLE = 'MVM Logistics';
router.afterEach((to) => {
	document.title = to.meta.title || DEFAULT_TITLE;
});

export default router
